import { RelayPatchCachingServersBaseDataProvider } from './RelayPatchCachingServersBaseDataProvider';
import { RelayCachingServer } from '../types';

export class RelayPatchCachingServersGzDataProvider extends RelayPatchCachingServersBaseDataProvider {
  async getRelayServers(params: any): Promise<{ data: RelayCachingServer[] }> {
    return this.dependencies.api.clients.ProtectedEntities.getSuperAgentsWithPatchManagementCacheServer(params);
  }
}
